import { lazy } from 'react';

export const PlayerCancelSessionLimitForm = lazy(
  () => import('./PlayerCancelSessionLimitForm'),
);
